import { createSelector } from 'reselect';
import { getCustomerIdentifier } from '../../reducers/helpers/customer.helper';
var RecentCustomers = function RecentCustomers(store) {
  return store.customercare.recoverableUiState.recentCustomers;
};
export var EMPTY_CUSTOMERS = [];
export var RecentCustomersSelector = createSelector([RecentCustomers], function (recentCustomers) {
  if (recentCustomers) {
    var modifiedCustomerList = recentCustomers.data.customers.asMutable({
      deep: true
    });
    Object.keys(modifiedCustomerList).forEach(function (key) {
      modifiedCustomerList[key].displayName = getCustomerIdentifier(modifiedCustomerList[key]);
    });
    return modifiedCustomerList;
  }
  return EMPTY_CUSTOMERS;
});
export var IsPanelVisibleSelector = createSelector([RecentCustomers], function (recentCustomers) {
  return recentCustomers ? recentCustomers.isPanelVisible : false;
});